import ProfessionalEdit from './ProfessionalEdit';
import ProfessionalList from './ProfessionalList';

export default {
  name: 'professional',
  list: ProfessionalList,
  edit: ProfessionalEdit,
};
